import React, { Component } from 'react';
import { debounce } from 'lodash';
import styled, { keyframes } from 'styled-components';
import {B64Image} from '../components/B64Image';
import { motion } from 'framer-motion';
import {i18n} from '../i18n';
import {IconButton} from './Buttons';

const config = window.dodConfig;

const BoxBody = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: ${(p) => {
		if (typeof p.top === 'number') {
			return p.top;
		}
		return config.isLandscape && !p.top ? 5 : 0;
	}}%;
`;
export const Bkg = styled(B64Image)`
	position: absolute;
	top: ${p => p.t || 0}vw; 
	left: ${p => p.l || 0}vw;
	width: 100%; 
	height: 100%;
`;

const Message = styled(B64Image)`
	width: ${(p) => {
		if (typeof p.width === 'number') {
			return p.width;
		}
		return config.isLandscape ? (p.top ? 34 : 64) : 86;
	}}%;
	margin: 0
		${(p) => {
			if (typeof p.width === 'number') {
				return (100 - p.width) / 2;
			}
			return config.isLandscape ? (p.top ? 33 : 18) : 7;
		}}%;
	/* ${(p) => (config.isLandscape ? (p.top ? 33 : 18) : 7)}%; */
	position: absolute;
	top: ${(p) =>
		p.top ? 200 : 50}%; /* positions the message halfway down the "tutorial" or other banner if it exists */
	left: 0;
`;

/* not used */
const MessageBanner = styled(B64Image)`
	/* position: absolute; */
	margin: 0 15%;
	width: ${(p) => (config.isLandscape ? 25 : 70)}%;
	z-index: 1;
`;
export class MessageBox extends Component {
	render() {
		return (
			<BoxBody>
				{this.props.banner && <MessageBanner src="/assets/tutorial/banner_tutorial.png" />}
				<Message src={`/assets/tutorial/${this.props.msg}.jpg`} />
				{this.props.children}
			</BoxBody>
		);
	}
}
export class MessageBoxLandscape extends Component {
	render() {
		return (
			<BoxBody top={this.props.top || true}>
				{this.props.banner && <MessageBanner src="/assets/tutorial/banner_tutorial_blank.png" />}
				<Message width={this.props.width} src={`/assets/tutorial/${this.props.msg}.jpg`} top />
				{this.props.children}
			</BoxBody>
		);
	}
}
/* end not used*/

const ButtonBarInner = styled.div`
	padding: 2% 0;
	width: 100%;
	flex-basis: 0;
	display: flex;
	justify-content: space-evenly;
	& .sprite {
		height: 15.5vw;
	}
	@media (min-aspect-ratio: 9/15) {
		& .sprite {
			height: 14vw;
		}
	}
`;
export class ButtonBar extends Component {
	render() {
		return (
			<ButtonBarInner className={`button-bar ${this.props.className}`} 
				style={this.props.style} 
				rightAlign={this.props.rightAlign}>
				{this.props.children}
			</ButtonBarInner>
		);
	}
}

const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}

	50% {
		transform: rotate(180deg);
	}

	100% {
		transform: rotate(360deg);
	}
`;

const SpinnerPositioner = styled(motion.div)`
	position: absolute;
	top: 0;
	left: 0;
	height: 50vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: none;
	z-index: 10000;
`;

const SpinnerBody = styled.div`
	width: ${(p) => (config.isLandscape ? 18 : 25)}%;
	position: relative;
`;

const Inner = styled(B64Image)`
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
`;
const Outer = styled(B64Image)`
	width: 100%;
	position: absolute;
	animation: ${rotate} 800ms linear infinite;
	top: 0;
	left: 0;
	z-index: 1;
`;

export class Spinner extends Component {
	render() {
		const variants = {
			visible: { opacity: 1, transition: { delay: 0.25, duration: 1 } },
			hidden: { opacity: 0, transition: { delay: 0, duration: 0.1 } },
		};
		return (
			<SpinnerPositioner initial="hidden" animate="visible" exit={'hidden'} variants={variants}>
				<SpinnerBody>
					<Outer src="/assets/spinner_ring.png" />
					<Inner src="/assets/spinner_icon.png" />
				</SpinnerBody>
			</SpinnerPositioner>
		);
	}
}

const Text = styled.span`
	white-space: nowrap;
	text-shadow: -2px -2px 0 ${(p) => p.stroke}, 2px -2px 0 ${(p) => p.stroke}, -2px 2px 0 ${(p) => p.stroke},
		2px 2px 0 ${(p) => p.stroke};
`;

export const stepShadow = (steps, width, color) => {
	let css = "";
	for (let i = 0; i < steps; i++) {
	  let angle = (i * 2 * Math.PI) / steps;
	  let cos = Math.round(10000 * Math.cos(angle)) / 10000;
	  let sin = Math.round(10000 * Math.sin(angle)) / 10000;
	  css += `calc(${cos} * ${width}) calc(${sin} * ${width}) 0 ${color}`;
	  if(i !== steps-1) css += ','
	}
	return css;
};
export const StrokeText = styled.span`
	text-shadow: ${p => stepShadow(16, p.stroke, p.color) + (p.add ? ', '+p.add : '')};
}`
export const NameTag = styled(p => {
	return <div className={p.className}>
		<div className='bottom'>
			<div className='top'>
				<StrokeText 
					stroke='0.2vw' color='#cb651d' 
					add='0 0.4vw 0 #8f3a0e'
				>
					{p.children}
				</StrokeText>
			</div>
		</div>
	</div>
})`
    margin-top: -2vw;
    z-index: 1;
	font-weight: 800;
	font-size: 3.5vw;
	position: inherit;

	.top {
		padding: 0 1.3vw;
		background-color: #ff9630;
		border-radius: 0.8vw;
		box-shadow: 0 0.1vw 0.2vw rgb(0 0 0 / 20%);
		white-space: nowrap;
	}

	& .bottom {
		border-radius: 0.8vw;
		background-image: linear-gradient(to right, #e16d25 0%,#b6541f 15%,#9e3916 38%,#9e3916 62%,#b6541f 85%,#e16d25 100%);
		box-shadow: inset 0 0 0.1vw 0.1vw #e2862f, 0 0.2vw 0.2vw #00000066;
		padding-bottom: 0.8vw;
	}
`;

export function calcTextSize(size) {
	var base = 930;
	if (config.isLandscape) {
		return (window.innerWidth / base) * size;
	} else {
		return (window.innerHeight / base) * size;
	}
}

export class PercenText extends Component {
	constructor(props) {
		super(props);
		window.addEventListener('resize', this.onResize);

		this.state = {
			size: calcTextSize(props.size),
		};
	}

	setTextSize = debounce(
		(size) => {
			this.setState({
				size: calcTextSize(size),
			});
		},
		250,
		{ maxWait: 250 }
	);

	onResize = () => {
		console.log('resize');
		this.setTextSize(this.props.size);
	};

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	render() {
		return (
			<Text stroke={this.props.stroke} style={{ fontSize: this.state.size + 'px' }}>
				{this.props.children}
			</Text>
		);
	}
}

PercenText.defaultProps = {
	size: 20,
	stroke: 'rgba(0,0,0,0)',
};

export const Question = styled(p => {return (
	<div className={p.className}>
		<IconButton size={7}
			src="/assets/buttons/btn_help.png"
			onClick={p.onClick}
		/>
	</div>
)})`
	position:absolute;
	top: 5vw;
	right: ${p => p.r || 10}vw;
`;

export const ScrollContainer = styled(motion.div)`
	background: url(${p => p.bkg}) center/100% 100% no-repeat;
	width: ${p => p.w}vw;
	flex: 1 0 30vh;
	position: relative;
	overflow: hidden;

	::after {
		content: '';
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		background: url(${p => p.overlay}) center/100% 100% no-repeat;
		pointer-events: none;
	}
`;
export const Scroller = styled(motion.div)`
	padding: 0.59vh 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	-webkit-overflow-scrolling: touch;
	overflow-y: scroll;
	&::-webkit-scrollbar {
		width: 0 !important;
		height: 0 !important;
	}
`;
export const ScrollArrow = styled(p => {return (
	<motion.div className = {p.className}
		initial={{bottom: '3vw', opacity: 0}}
		animate={{bottom: ['0vw', '-3vw', '0vw'], opacity: 1}}
		transition={{
			bottom: {
				type: 'tween', ease: 'easeInOut', 
				duration: 2, loop: Infinity,
				times: [0, 0.5, 1]
			},
			opacity: {duration: 0.5}
		}}
		exit={{opacity: 0, duration: 0.5}}
	>
		<B64Image src="/assets/arrow_white.png"/>
	</motion.div>
)})`
	position:absolute;
	width:100%;
	z-index: 2;
	bottom: 0vw;

	img { width: 15vw; }
`;

export const stringToTags = str => {
	const split = str.match(/(<\w+>)?(\w|\s|([.,!?:;'"'\-()™+%*])|[\u00c0-\u00dd]|\u00a1|\u00bf)+(<\/\w+>)?/gi);
	let i = 0;
	const tags = split.map(ch => {
		const hasTag = ch.indexOf('<') === 0;
		const ind = ch.indexOf('>');
		const tName = ch.slice(1, ind);
		const content = ch.slice(ind+1, ch.indexOf('<', ind));
		const CustomTag = `${tName}`
		const obj = <CustomTag key={tName+tName + i++}>{content}</CustomTag>
		return hasTag ? obj : ch;
	});	
	//console.log('OUTLINE :: str =', str, 'spl =', split, 't =', tags)
	return tags		
}
export const Outline = styled(p => { 
	return (
	<div className = {p.className}>
		<StrokeText color={p.color || '#792c02'} stroke={(p.stroke || 0.5) + "vw"}>
			{p.children ? typeof(p.children) === 'string' ? stringToTags(p.children)
			 : p.children.map(ch => typeof(ch) === 'string' ? stringToTags(ch) : ch) 
			: i18n.exists(p.textKey) ? stringToTags(i18n.t(p.textKey)) : p.textKey}
		</StrokeText>
	</div>
)})`
	b { font-weight: bolder; }
`;
export const OutlineWithBold = styled(p => {
	const content = () => {
		if(p.children) {
			return p.children
		} else if (p.textKey) {
			const trans = i18n.t(p.textKey);
			const arr = trans.split('*');
			return arr.length > 1 ?
				arr.map((textPart, i) => 
					i18n.exists(textPart) ? <b key={'bb'+i}>{i18n.t(textPart)}</b> 
						
					: textPart
				) : trans;
		} else {
			return 'You forgot to add text!!'
		}
	}
	return <Outline className={p.className} stroke={p.stroke}>
		{content()}
	</Outline>
})`
	b { font-weight: 900; }
`;

export const Badge = styled(p => { 
	return !p.num ? null : (
	<div className={p.className}>
		<Bkg src="/assets/btn_nav_new_ach.png" className='badgeBkg'/>
		<div>{p.num}</div>
	</div>
)})`
	position: absolute;
	top: ${p => p.top || -3}vw;
	right: ${p => p.right || 0}vw;
	width: ${p => p.size || 9}vw;
	height: ${p => p.size || 9}vw;
	display: flex;
    justify-content: center;
    align-items: center;

	div {
		position: relative;
		text-shadow: 0 0.46vw 0 #00000066;
		font-weight: 900;
		font-size: ${p => p.size/2 || 4.5}vw;
		top: ${p => p.t || -0.5}vw;
	}
`;

export const HeaderBanner = styled(p => { return (
	<div className={p.className}>
		<Bkg src="assets/leagues/banner_leaguesOverlay_blank.png"/>
		<HeaderTitle fs={p.fs} w={p.w}>
			{i18n.t(p.textKey)}
		</HeaderTitle>
	</div>
)})`
	width: ${p => p.w}vw;
	--hei: ${p => 229/1221 *p.w}vw;
	height: var(--hei);
    display: flex;
    align-items: flex-start;
    justify-content: center;
	flex: 0 0 auto;
	position: relative;
	color: white;
	margin-bottom: calc(-0.4 * var(--hei));
`;

const HeaderTitle = styled.div`
	font-size: min(calc(0.47 * var(--hei)), ${p => p.fs || '6'}vw);
	font-weight: 800;
	text-transform: uppercase;
	text-shadow: 0 0.1vw 0 #000000b3;
	width: ${p => 0.65*p.w}vw;
	white-space: nowrap;
	text-align: center;
    line-height: calc(0.7 * var(--hei));
	position: relative;
	top: calc(0.05 * var(--hei));
	transform: scaleX(min(1, calc(13/${p => p.children.length})));
`;